import { useTranslation } from 'react-i18next';

type UserAction = 'edit' | 'remove' | 'resend';

interface UsersTableActionMenuProps {
  userId: string;
  position: { top: number; right: number };
  removeLabel: string;
  onAction: (userId: string, action: UserAction) => void;
  onClose: () => void;
}

export const UsersTableActionMenu = ({
  userId,
  position,
  removeLabel,
  onAction,
  onClose,
}: UsersTableActionMenuProps) => {
  const { t } = useTranslation();

  const handleAction = (action: UserAction) => {
    onAction(userId, action);
    onClose();
  };

  return (
    <div
      className="action-menu fixed z-50 w-48 bg-white rounded-md shadow-lg border border-gray-200"
      style={{ top: `${position.top}px`, right: `${position.right}px` }}
    >
      <div className="py-1">
        <button
          onClick={() => handleAction('resend')}
          className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
        >
          {t('admin.users.actions.resend_invite')}
        </button>
        <button
          onClick={() => handleAction('edit')}
          className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
        >
          {t('admin.users.actions.edit')}
        </button>
        <button
          onClick={() => handleAction('remove')}
          className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
        >
          {removeLabel}
        </button>
      </div>
    </div>
  );
};
